import { useEventListener } from "@react-hookz/web";
import type React from "react";
import { useBlocker as useBlockerReactRouter } from "react-router";

export const makeLazyRoute = <TComponentName extends string>(
  componentImport: () => Promise<{ [Key in TComponentName]: React.ComponentType }>,
  componentName: TComponentName,
): (() => Promise<{ Component: React.ComponentType }>) => {
  return () => componentImport().then((module) => ({ Component: module[componentName] }));
};

export const useBlocker = (when: boolean) => {
  useEventListener(window, "beforeunload", (e: BeforeUnloadEvent) => {
    if (!when) return;
    e.preventDefault();
    // included for legacy support
    e.returnValue = "You have unsaved changes, are you sure?";
  });
  return useBlockerReactRouter(when);
};
